import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User, UserSecret } from './default/loan-prov/user.model';
import { PredictModel } from './default/inner/inner.model';
import { AppService } from '../../app.service';



@Injectable()
export class ApiService {
    private serviceURILoan = 'loanapplication/data/';
    private serviceURIAccount = 'account/';

    constructor(private service: AppService) { }


    getCategorical(): Observable<any[]> {
        return this.service.get(`${this.serviceURILoan}categoricaldata`);
    }

    getExistingAppID(cnic: string): Observable<any[]> {
        return this.service.post(`${this.serviceURILoan}accountnumber`,
            { Client_CNIC: cnic });
    }

    postAppID(
        Client_Name: string,
        Client_CNIC: string,
        Marital_Status: string,
        Nationality: string,
        Qualification: string,
        Date_Of_Birth: string,
        Profession: string,
        Residence_Type: string,
        Accomodation_Type: string,
        Rent_Amount: string,
        living_at_residence_since: string,
        Net_Income: string,
        No_of_dependent: string,
        Other_Banks_Loan: string,

        Legal_Status: string,
        Date_Of_Establishment: string,
        Business_Place_Status: string,
        No_Of_Partners: string,
        Share_In_Business: string,
        Business_Capital_Amount: string,
        Business_Net_Amount: string,
        No_Of_Employess: string,

        NetIncomeBusinessmMonthly: string,
        NetDisposableBusinessMonthly: string,

        Loan_OfficerID: string,
        Application_Number: string,
        Loan_Purpose: string,
        Loan_Product: string,
        Sector: string,
        Loan_Tenure: string,
        LoanAmount: string,
        Branch_Name: string,

        Sales: string,
        TVCost: string,
        FCost: string,
        HHExpense: string,

        InterestRate: string,
        DocumentCharge: string,
        InsuranceRate: string,
        InsuranceAmount: string,
        MailThrough: string

    ): Observable<any[]> {
        return this.service.post(`${this.serviceURILoan}newclient`,
            {
                "Branch_Name": Branch_Name,
                "NetBusinessIncome": +NetIncomeBusinessmMonthly,
                "NetDisposableIncome": +NetDisposableBusinessMonthly,
                "Client_CNIC": Client_CNIC,
                "Application_Number": Application_Number,
                "Client_Name": Client_Name,
                "Nationality": Nationality,
                "Marital_Status": Marital_Status,
                "Qualification": Qualification,
                "Date_Of_Birth": Date_Of_Birth,
                "Profession": Profession,
                "Residence_Type": Residence_Type,
                "Accomodation_Type": Accomodation_Type,
                "Rent_Amount": +Rent_Amount,
                "living_at_residence_since": +living_at_residence_since,
                "Net_Income": Net_Income,
                "No_of_dependent": +No_of_dependent,
                "Legal_Status": Legal_Status,
                "Date_Of_Establishment": +Date_Of_Establishment,
                "Business_Place_Status": Business_Place_Status,
                "No_Of_Partners": No_Of_Partners,
                "Share_In_Business": Share_In_Business,
                "Business_Capital_Amount": Business_Capital_Amount,
                "Business_Net_Amount": Business_Net_Amount,
                "No_Of_Employess": No_Of_Employess,
                "LoanOfficer_Id": Loan_OfficerID,
                "Loan_Purpose": Loan_Purpose,
                "Loan_Tenure": +Loan_Tenure,
                "totalprincipaldue": +LoanAmount,
                "Sector": Sector,
                "Other_Banks_Loan": +Other_Banks_Loan,
                "Loan_Product": Loan_Product,

                "Sales": Sales,
                "TVCost": TVCost,
                "FCost": FCost,
                "HHExpense": HHExpense,

                "InterestRate": +InterestRate,
                "DocumentCharge": +DocumentCharge,
                "InsuranceRate": +InsuranceRate,
                "InsuranceAmount": +InsuranceAmount,
                "MailThrough": MailThrough
            });
    }




    putAppID(
        Client_Name: string,
        Client_CNIC: string,
        Marital_Status: string,
        Nationality: string,
        Qualification: string,
        Date_Of_Birth: string,
        Profession: string,
        Residence_Type: string,
        Accomodation_Type: string,
        Rent_Amount: string,
        living_at_residence_since: string,
        Net_Income: string,
        No_of_dependent: string,
        Other_Banks_Loan: string,

        Legal_Status: string,
        Date_Of_Establishment: string,
        Business_Place_Status: string,
        No_Of_Partners: string,
        Share_In_Business: string,
        Business_Capital_Amount: string,
        Business_Net_Amount: string,
        No_Of_Employess: string,

        NetIncomeBusinessmMonthly: string,
        NetDisposableBusinessMonthly: string,

        Loan_OfficerID: string,
        Application_Number: string,
        Loan_Purpose: string,
        Loan_Product: string,
        Sector: string,
        Loan_Tenure: string,
        LoanAmount: string,
        Branch_Name: string,

        Sales: string,
        TVCost: string,
        FCost: string,
        HHExpense: string,

        InterestRate: string,
        DocumentCharge: string,
        InsuranceRate: string,
        InsuranceAmount: string,
        MailThrough: string
    ): Observable<any[]> {
        return this.service.post(`${this.serviceURILoan}existingclient`,
            {
                "Branch_Name": Branch_Name,
                "NetBusinessIncome": +NetIncomeBusinessmMonthly,
                "NetDisposableIncome": +NetDisposableBusinessMonthly,
                "Client_CNIC": Client_CNIC,
                "Application_Number": Application_Number,
                "Client_Name": Client_Name,
                "Nationality": Nationality,
                "Marital_Status": Marital_Status,
                "Qualification": Qualification,
                "Date_Of_Birth": Date_Of_Birth,
                "Profession": Profession,
                "Residence_Type": Residence_Type,
                "Accomodation_Type": Accomodation_Type,
                "Rent_Amount": +Rent_Amount,
                "living_at_residence_since": +living_at_residence_since,
                "Net_Income": +Net_Income,
                "No_of_dependent": +No_of_dependent,
                "Legal_Status": Legal_Status,
                "Date_Of_Establishment": +Date_Of_Establishment,
                "Business_Place_Status": Business_Place_Status,
                "No_Of_Partners": No_Of_Partners,
                "Share_In_Business": Share_In_Business,
                "Business_Capital_Amount": Business_Capital_Amount,
                "Business_Net_Amount": Business_Net_Amount,
                "No_Of_Employess": No_Of_Employess,
                "LoanOfficer_Id": Loan_OfficerID,
                "Loan_Purpose": Loan_Purpose,
                "Loan_Tenure": +Loan_Tenure,
                "totalprincipaldue": +LoanAmount,
                "Sector": Sector,
                "Other_Banks_Loan": +Other_Banks_Loan,
                "Loan_Product": Loan_Product,

                "Sales": Sales,
                "TVCost": TVCost,
                "FCost": FCost,
                "HHExpense": HHExpense,

                "InterestRate": +InterestRate,
                "DocumentCharge": +DocumentCharge,
                "InsuranceRate": +InsuranceRate,
                "InsuranceAmount": +InsuranceAmount,
                "MailThrough": MailThrough
            });
    }

    getUserList(): Observable<any[]> {
        return this.service.get(`${this.serviceURIAccount}r/`);
    }

    getUserById(Id: string): Observable<any[]> {
        return this.service.get(`${this.serviceURIAccount}r/` + Id);
    }

    createUser(user: UserSecret): Observable<any> {
        return this.service.post(`${this.serviceURIAccount}r/`, user);
    }

    updateUser(userId: number, user: User): Observable<number> {
        return this.service.put(`${this.serviceURIAccount}r/`, userId, user);
    }
    getPerformanceModel(branch: string, startdt: string, enddt: string): Observable<any[]> {
        return this.service.post(`loanapplication/performance/datafilter`,
            {
                "Branch_Name": branch,
                "startdate": startdt,
                "enddate": enddt
            }
        );
    }

    deleteUser(userId: number): Observable<number> {
        return this.service.delete(`${this.serviceURIAccount}r/`, userId);
    }

    predictLoan(pModel: PredictModel): Observable<any[]> {
        return this.service.post(`${this.serviceURILoan}newclient`, pModel);
    }



}





// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/theme/pages/api-service.service.ts